import React from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'validate.js';
import classnames from 'classnames';

import SmartLink from 'dpl/components/SmartLink';
import SmartImage from 'dpl/components/SmartImage';
import useBreedDescriptionModal from 'dpl/breeder_search_results/hooks/useBreedDescriptionModal';

export default function BreedContentModule() {
  const { breedName, breedContentData, breedOverviewPageUrl } = useSelector(
    state => state.server
  );

  const hasTraits = !isEmpty(breedContentData.traits);
  const hasBreedCitySummary = breedContentData.has_breed_city_summary;

  const { openModal } = useBreedDescriptionModal();

  return (
    <div className="BreedContentModule container-xxl pv10 pv16-md">
      <div className="flex flex-column flex-md-row items-center gap-x-64 gap-y-32">
        <div className="w-100">
          {breedContentData.photos.length === 3 ? (
            <div className="BreedContentModule__photos br3 overflow-hidden">
              {breedContentData.photos.map((photo, idx) => (
                <SmartImage
                  key={idx}
                  className="h-100 w-100 object-cover"
                  loadingClass="bg-light-gray"
                  src={photo.photo_url}
                  alt={photo.alt_text}
                />
              ))}
            </div>
          ) : (
            <div className="aspect-ratio aspect-ratio--16x9 relative">
              <div className="aspect-ratio--object">
                <SmartImage
                  Tag="div"
                  className="w-100 h-100 cover bg-center"
                  wrapperOnlyClassName="br3 overflow-hidden"
                  loadingClass="bg-light-gray"
                  src={breedContentData.photos[0].photo_url}
                  alt={breedContentData.photos[0].alt_text}
                />
              </div>
            </div>
          )}
        </div>
        <div className="w-100">
          <h4 className="font-24 md:font-32 lh-title mb2 mb4-md">
            About the {breedName}
          </h4>
          <p
            className={classnames('secondary font-16', {
              'pre-line': hasBreedCitySummary
            })}
          >
            {breedContentData.description}
            {!hasBreedCitySummary && (
              <>
                {' '}
                {breedOverviewPageUrl ? (
                  <SmartLink
                    to={breedOverviewPageUrl}
                    target="_blank"
                    rel="noreferrer"
                    data-test-id="breed_overview_learn_more_link"
                    className="midnight underline"
                  >
                    Learn more
                  </SmartLink>
                ) : (
                  <button
                    type="button"
                    onClick={openModal}
                    data-test-id="breed_description_learn_more_button"
                    className="midnight underline"
                  >
                    Learn more
                  </button>
                )}
              </>
            )}
          </p>
          {hasTraits && (
            <div className="flex flex-column flex-md-row flex-wrap mt8 mt14-md gap-8">
              {breedContentData.traits.map((trait, idx) => (
                <div
                  key={idx}
                  className="bg-white br3 pv6 ph4 flex flex-column justify-center items-center flex-basis-0 flex-grow-1 tc"
                >
                  <p className="BreedContentModule__traitDescription font-serif font-20 mb2">
                    {trait.description}
                  </p>
                  <p className="secondary font-14">{trait.category}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
